import { CreditCardNumberSettings } from './type';

export const creditCardNumberSettings: CreditCardNumberSettings = {
  componentVariants: {
    variant: {
      prop: 'variant',
      variants: {
        regular: {
          color: 'black.main',
        },
      },
    },
  },
};
